import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

interface PrivateRouteProps {
  children: React.ReactNode
}

export const SSO_RETURN_KEY = 'sso:returnPath'

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    sessionStorage.setItem(SSO_RETURN_KEY, window.location.pathname)
    return <Navigate to="/sso" replace />
  }
  return <>{children}</>
}
